import PageMeta from 'components/PageMeta'
import React, { useEffect, useState } from 'react'
import PageLayout from 'components/pages/PageLayout'
import { withApollo } from 'components/withApollo'
import { NextPage } from 'next'
import HeroSection from 'components/pages/ExperientialMarketingPage/HeroSection'
import AboutUsSection from 'components/pages/ExperientialMarketingPage/AboutUsSection'
import ExperientialMarketingForm from 'components/pages/ExperientialMarketingPage/ExperientialMarketingFormModal'
import ClientCaseSection from 'components/pages/ExperientialMarketingPage//ClientCaseSection'
import { useRouter } from 'next/router'
import ClientClouds from 'components/ClientClouds'
import ChatWidget from 'components/ChatWidget'

const ExperientialMarketingPage = () => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  const openForm = () => setOpenModal(true)
  const router = useRouter()
  useEffect(() => {
    if (router.query.open) {
      openForm()
    }
  }, [router.query])
  return (
    <>
      <ChatWidget />
      <PageLayout fullWidth gray staticPage>
        <PageMeta
          canonicalPath="/experiential-marketing"
          description="Experiential Marketing division specializes in immersing
            consumers through revolutionary branded mobile experiences that are
            creatively fun, interactive and maximize direct customer engagement"
          keywords="food trucks, experiential marketing"
          title="Best Food Trucks | Experiential Marketing"
        />
        <ExperientialMarketingForm
          onClose={() => setOpenModal(false)}
          open={openModal}
        />
        <div className="w-full">
          <HeroSection openForm={openForm} />
          <ClientClouds
            clients={[
              'mcCormick',
              'albertsons',
              'apple',
              'cbs',
              'brookfield',
              'pfizer',
              'swedish',
              'claremont'
            ]}
          />
          <AboutUsSection openForm={openForm} />
          <ClientCaseSection />
        </div>
      </PageLayout>
    </>
  )
}

export default withApollo({ ssr: false })(ExperientialMarketingPage as NextPage)
